import { useCallback } from 'react';

import { useDrawer } from '@cast/design-system';
import { OptimizationWorkload } from '@cast/types';

import { CostReportWorkloadDetailsDrawer } from './CostReportWorkloadDetailsDrawer';

export const useCostReportWorkloadDetailsDrawer = () => {
  const { open } = useDrawer();

  const openWorkloadDetailsDrawer = useCallback(
    (rawWorkload: OptimizationWorkload) => {
      open({
        component: CostReportWorkloadDetailsDrawer,
        props: { rawWorkload },
      });
    },
    [open]
  );

  return {
    openWorkloadDetailsDrawer,
  };
};
